function readMore(){
  // Read-more/less logic----

  const readMore = document.querySelector('.Read_more');
  let descShort = document.getElementById('Fragrance__Desc--truncate');
  let descLong = document.getElementById('Fragrance__Desc--full');

  if (descLong.innerHTML.split(' ').length >= 30) {
    readMore.hidden = false;
  }

  if (!readMore) {
    return;
  } else {
    readMore.addEventListener('click', (e) => {
      let btn = readMore;
      let dataOpen = btn.getAttribute('data-text-open');
      let textMore = readMore.querySelector('.text-more');
      let textLess = readMore.querySelector('.text-less');

      if (dataOpen == 'false') {
        descShort.hidden = true;
        descLong.hidden = false;
        btn.setAttribute('data-text-open', 'true');
        textMore.hidden = true;
        textLess.hidden = false;

      } else {
        descShort.hidden = false;
        descLong.hidden = true;
        btn.setAttribute('data-text-open', 'false');
        textMore.hidden = false;
        textLess.hidden = true;
      }
    });
  }
}

function checkUserIP(){
  getUserCountry().then(response => {
    let isUserIpValid = checkUserIPValid(response.detected_values.country.handle);
    if (!isUserIpValid){
      replaceAddToCartButton();
    }
  })
}

function replaceAddToCartButton(){
  let form = document.querySelector('form[action*="/cart/add"]'),
    addToCartButton = form.querySelector('button[type="submit"]');
  if (form && addToCartButton){
    form.addEventListener('submit', addToCartRedirect);
    addToCartButton.querySelector('.add-cart-icon').innerHTML = window.languages.productFormWhereToBuy;
  }
}

function addToCartRedirect(e){
  e.preventDefault();
  window.location.href = window.theme.partner_store_url;
}

function checkUserIPValid(user_country){
  let partner_stores = window.theme.partner_store_list.split(',');
  if (partner_stores.includes(user_country)){
    return false
  }else{
    return true
  }
}

function getUserCountry(){
  return new Promise((resolve) => {
    fetch('/browsing_context_suggestions.json').then((response) => resolve(response.json()))
  })
}

document.addEventListener('DOMContentLoaded', function (event) {
  readMore();
  checkUserIP();
});
